'use client';

import { createContext } from 'react';

import type { BehaviorSubject, Subject } from 'rxjs';

import type { ChatMessage } from '../../types/ChatMessage';

export interface ChatMessagesStatus {
  isLoading: boolean;
  isLoadingMore?: boolean;
  hasMore: boolean;
  error: unknown | undefined;
}

export interface ChatMessageContextValue {
  messages$: BehaviorSubject<ChatMessage[]>;
  status$: BehaviorSubject<ChatMessagesStatus>;
  newMsgReceived$: Subject<ChatMessage>;
  loadMoreMessages: () => Promise<void>;
}

export const ChatMessageContext = createContext<ChatMessageContextValue | null>(
  null,
);
